(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-cart-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ys5-cart]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('[data-ys5-cart-form]');
      const update = root.querySelector('[data-ys5-cart-update]');
      if (!form || !update) return;
      let timer;
      const submitUpdate = () => {
        clearTimeout(timer);
        timer = setTimeout(() => form.requestSubmit ? form.requestSubmit(update) : form.submit(), 350);
      };
      root.querySelectorAll('.ys5-cart-item').forEach((item) => {
        const input = item.querySelector('input[name="updates[]"]');
        item.querySelector('[data-ys5-cart-minus]')?.addEventListener('click', () => {
          input.value = Math.max(0, Number.parseInt(input.value || '0', 10) - 1);
          submitUpdate();
        });
        item.querySelector('[data-ys5-cart-plus]')?.addEventListener('click', () => {
          input.value = Math.max(0, Number.parseInt(input.value || '0', 10) + 1);
          submitUpdate();
        });
        input?.addEventListener('change', submitUpdate);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-collection-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ys5-sort]').forEach((select) => {
      if (select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => select.form?.submit());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-header-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ys5-header]').forEach((header) => {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';
      const button = header.querySelector('[data-ys5-menu-button]');
      const navigation = header.querySelector('[data-ys5-mobile-nav]');
      const dialog = header.querySelector('[data-ys5-search-dialog]');
      const input = header.querySelector('[data-ys5-search-input]');
      const results = header.querySelector('[data-ys5-search-results]');
      const searchOpeners = header.querySelectorAll('[data-ys5-search-open]');
      const searchClose = header.querySelector('[data-ys5-search-close]');
      if (!button || !navigation || !dialog || !input || !results) return;

      let searchTimer;
      let searchRequest;
      let lastOpener;
      const searchCache = new Map();

      const closeMenu = (restoreFocus = false) => {
        button.setAttribute('aria-expanded', 'false');
        navigation.hidden = true;
        document.body.classList.remove('ys5-menu-open');
        if (restoreFocus) button.focus();
      };

      const openMenu = () => {
        button.setAttribute('aria-expanded', 'true');
        navigation.hidden = false;
        document.body.classList.add('ys5-menu-open');
        navigation.querySelector('a')?.focus();
      };

      const showSearchMessage = (message) => {
        const paragraph = document.createElement('p');
        paragraph.className = 'ys5-search-dialog__message';
        paragraph.textContent = message;
        results.replaceChildren(paragraph);
        results.setAttribute('aria-busy', 'false');
      };

      const closeSearch = () => {
        clearTimeout(searchTimer);
        searchRequest?.abort();
        if (dialog.open) dialog.close();
      };

      const openSearch = (opener) => {
        closeMenu();
        lastOpener = opener;
        if (!dialog.open) dialog.showModal();
        document.body.classList.add('ys5-search-open');
        window.requestAnimationFrame(() => input.focus());
      };

      const requestSuggestions = async (query) => {
        if (searchCache.has(query)) {
          results.innerHTML = searchCache.get(query);
          results.setAttribute('aria-busy', 'false');
          return;
        }

        searchRequest?.abort();
        searchRequest = new AbortController();
        results.setAttribute('aria-busy', 'true');
        showSearchMessage(header.dataset.searchLoadingLabel);
        results.setAttribute('aria-busy', 'true');

        const url = new URL(header.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('section_id', 'ys-predictive-search');

        try {
          const response = await fetch(url.toString(), { signal: searchRequest.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(String(response.status));
          const markup = await response.text();
          if (input.value.trim() !== query) return;
          searchCache.set(query, markup);
          results.innerHTML = markup;
          results.setAttribute('aria-busy', 'false');
        } catch (error) {
          if (error.name === 'AbortError') return;
          showSearchMessage(header.dataset.searchErrorLabel);
        }
      };

      button.addEventListener('click', () => {
        if (button.getAttribute('aria-expanded') === 'true') closeMenu();
        else openMenu();
      });
      navigation.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu()));
      searchOpeners.forEach((opener) => opener.addEventListener('click', () => openSearch(opener)));
      searchClose?.addEventListener('click', closeSearch);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeSearch();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('ys5-search-open');
        lastOpener?.focus();
      });
      input.addEventListener('input', () => {
        clearTimeout(searchTimer);
        const query = input.value.trim();
        if (query.length === 0) {
          searchRequest?.abort();
          showSearchMessage(header.dataset.searchEmptyLabel);
          return;
        }
        searchTimer = window.setTimeout(() => requestSuggestions(query), 180);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeSearch();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') closeMenu(true);
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 860) closeMenu();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-home-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewPanels = (root) => {
      if (root.dataset.ys5ReviewPanelsReady === 'true') return;
      root.dataset.ys5ReviewPanelsReady = 'true';
      const panels = [...root.querySelectorAll('[data-ys5-review-panel]')];

      const activate = (selected) => {
        panels.forEach((panel) => panel.classList.toggle('is-active', panel === selected));
      };

      panels.forEach((panel) => {
        panel.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') activate(panel);
        });
        panel.addEventListener('focusin', () => activate(panel));
        panel.addEventListener('pointerdown', () => activate(panel));
      });
    };

    document.querySelectorAll('[data-ys5-review-panels]').forEach(initializeReviewPanels);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-ys5-review-panels]').forEach(initializeReviewPanels);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-product-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ys5-product]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-ys5-quantity-input]');
      const variant = root.querySelector('[data-ys5-variant-select]');
      const submit = root.querySelector('[data-ys5-add-to-cart]');
      const submitLabel = root.querySelector('[data-ys5-add-label]');
      const price = root.querySelector('[data-ys5-product-price]');
      const availability = root.querySelector('[data-ys5-product-availability]');
      const gallery = root.querySelector('[data-ys5-gallery]');
      const slides = [...root.querySelectorAll('[data-ys5-gallery-slide]')];
      const thumbs = [...root.querySelectorAll('[data-ys5-gallery-thumb]')];
      let galleryIndex = 0;

      const showGalleryImage = (index) => {
        if (!slides.length) return;
        galleryIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, itemIndex) => {
          const active = itemIndex === galleryIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((thumb, itemIndex) => {
          const active = itemIndex === galleryIndex;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.setAttribute('aria-selected', 'true');
          else thumb.removeAttribute('aria-selected');
        });
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showGalleryImage(index)));
      gallery?.querySelector('[data-ys5-gallery-prev]')?.addEventListener('click', () => showGalleryImage(galleryIndex - 1));
      gallery?.querySelector('[data-ys5-gallery-next]')?.addEventListener('click', () => showGalleryImage(galleryIndex + 1));

      root.querySelector('[data-ys5-quantity-minus]')?.addEventListener('click', () => {
        input.value = Math.max(1, Number.parseInt(input.value || '1', 10) - 1);
      });
      root.querySelector('[data-ys5-quantity-plus]')?.addEventListener('click', () => {
        input.value = Math.max(1, Number.parseInt(input.value || '1', 10) + 1);
      });
      input?.addEventListener('change', () => {
        input.value = Math.max(1, Number.parseInt(input.value || '1', 10) || 1);
      });
      variant?.addEventListener('change', () => {
        const selected = variant.selectedOptions[0];
        const available = selected?.dataset.available === 'true';
        if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
        if (submit) {
          submit.disabled = !available;
          if (submitLabel) submitLabel.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldOutLabel;
        }
        if (availability) availability.textContent = available ? submit.dataset.inStockLabel : submit.dataset.soldOutLabel;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ys-spotlight-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ys5-video-cover]').forEach((cover) => {
      if (cover.dataset.ready === 'true') return;
      cover.dataset.ready = 'true';
      cover.addEventListener('click', () => {
        const media = cover.closest('.ys5-video-review__media');
        const video = media?.querySelector('video');
        if (!video) return;
        cover.hidden = true;
        video.play().catch(() => { cover.hidden = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
